import React, { useState } from 'react';
import './CommodityDetailModal.css'; // Reusing styles for consistency

const SelectLocationModal = ({ isOpen, onClose, locations, onConfirm }) => {
    const [selectedLocation, setSelectedLocation] = useState('');
    const [selectedKiosk, setSelectedKiosk] = useState('');

    if (!isOpen) {
        return null;
    }

    const handleConfirm = () => {
        if (!selectedLocation) {
            alert('Please select a location.');
            return;
        }
        onConfirm(selectedKiosk || selectedLocation);
    };

    return (
        <div className="modal-backdrop" onClick={onClose}>
            <div className="modal-content" onClick={e => e.stopPropagation()}>
                <button className="modal-close-button" onClick={onClose}>&times;</button>
                <h2>Select Storage Location</h2>
                <p>Choose the location or kiosk where you are storing this commodity.</p>
                <div className="modal-body">
                    <div className="location-selector">
                        <select 
                            value={selectedLocation} 
                            onChange={(e) => setSelectedLocation(e.target.value)}
                            className="location-select-dropdown"
                        >
                            <option value="">Select a location...</option>
                            {locations.map(location => (
                                <option key={location.id} value={location.id}>
                                    {location.name}
                                </option>
                            ))}
                        </select>
                    </div>
                    {/* Kiosk selector if location has kiosks */}
                    {selectedLocation && Array.isArray((locations.find(l => l.id === selectedLocation) || {}).kiosks) && (locations.find(l => l.id === selectedLocation) || {}).kiosks.length > 0 && (
                      <div className="location-selector" style={{ marginTop: 8 }}>
                        <select
                          value={selectedKiosk}
                          onChange={e => setSelectedKiosk(e.target.value)}
                          className="location-select-dropdown"
                        >
                          <option value="">Whole location (no kiosk)</option>
                          {(locations.find(l => l.id === selectedLocation).kiosks || []).map((k, i) => (
                            <option key={k.id || i} value={k.id || `${selectedLocation}::${i}`}>
                              {k.name} {Array.isArray(k.activities) && k.activities.length ? `(${k.activities.join('/')})` : ''}
                            </option>
                          ))}
                        </select>
                      </div>
                    )}
                    <div className="modal-actions">
                        <button onClick={handleConfirm} className="button-primary">Confirm</button>
                        <button onClick={onClose} className="button-secondary">Cancel</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SelectLocationModal; 